export const bem = {
  props: {
    classnameOverride: {
      type: String
    },
    extraClassnames: {
      type: [ Array, String ]
    },
    extraModifiers: {
      type: [ Function ]
    },
    identifier: {
      type: String
    }
  },
  computed: {
    classnames: function () {
      const ns = getNamespace(this)

      let modifiers = []

      if (hasClassnameModifiers(this)) {
        modifiers = this.classnameModifiers(ns)

        modifiers = prependNamespace(modifiers, ns)
      }

      if (this.extraModifiers) {
        let extraModifiers = this.extraModifiers()

        extraModifiers = prependNamespace(extraModifiers, ns)

        modifiers = modifiers.concat(extraModifiers)
      }

      return [
        ns,
        this.extraClassnames,
        modifiers
      ]
    },
    ns: function () {
      const ns = getNamespace(this)

      return ns
    },
    uniqueId: function () {
      return this.identifier || undefined
    }
  },
  methods: {
    setNamespace: function (namespace) {
      this.namespace = namespace
    }
  }
}

const getNamespace = function (component) {
  const {
    classnameOverride,
    namespace
  } = component

  const ns = classnameOverride || namespace || undefined

  return ns
}

const hasClassnameModifiers = function (component) {
  const {
    classnameModifiers
  } = component

  if (classnameModifiers && typeof classnameModifiers === 'function') {
    return true
  }

  return false
}

const doesModifierExists = function (modifier) {
  if (typeof modifier === 'string' && modifier !== '') {
    return true
  }

  return false
}

const prependNamespace = function (modifiers, namespace) {
  modifiers.forEach(function (modifier, index, modifierList) {
    const modifierExists = doesModifierExists(modifierList[index])

    if (modifierExists) {
      modifierList[index] = `${namespace}--${modifier}`
    }
  })

  return modifiers
}



// WEBPACK FOOTER //
// ./src/js/mixins/bem.js